<script lang="ts">
	import { format } from 'svelte-i18n';

	import { os } from 'src/stores/session/native-bridge';

	import WiFiListInclusion from './WiFiListInclusion.svelte';
	import WiFiTypeInclusion from './WiFiTypeInclusion.svelte';
	import BleListInclusion from './BleListInclusion.svelte';
	import DiscoveredDevicesListHolder from 'src/components/Lists/Devices/DiscoveredDevicesListHolder.svelte';

	import { Alert } from '@Shelly/shelly-design-system';

	export let inclusionData;
</script>

{#if inclusionData?.selectVia == 'wifi'}
	{#if $os === 'IOS'}
		<WiFiTypeInclusion bind:inclusionData />
	{:else}
		<WiFiListInclusion bind:inclusionData />
	{/if}
{:else if inclusionData?.selectVia == 'ble'}
	<BleListInclusion bind:inclusionData />
{:else if inclusionData?.selectVia == 'wifi_scan'}
	<DiscoveredDevicesListHolder bind:inclusionData />
{:else}
	<Alert
		type="danger"
		class="mb-s"
		heading={$format('alert_danger_title_unknown_inclusion_type', {
			default: 'Unclear inclusion method',
		})}
	/>
{/if}
